import { Injectable } from '@angular/core';

import { AuthService } from "../../shared/services/auth.service";
import { despachosRoute } from "./data.service";
import { obrigacoesRoute } from "../obrigacoes/shared/data.service";

@Injectable()
export class DespachoService {

    constructor(
        private _authService: AuthService
    ) { }

    goToSettingObrigacoes() {
        let router: string = despachosRoute + '/' + obrigacoesRoute + '/configuracoes';
        this._authService.navigateTo(router);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/shared/despacho.service.ts
 **/